import React, { Component } from "react";
import "../Account.css"
import SignupHeader from "./signup.header";
import SignupFooter from "./signup.footer";
import { Link } from "react-router-dom";
import axios from "axios"
// import { FaGooglePlusG } from "react-icons/fa";
import GoogleSignup from "./google.signup";




class Login extends Component {
  state = {
    email: '',
    password: '',
    error: null,
    accessToken: null,
    loading: false, // Added loading state
  }


  componentDidMount() {
    const accessToken = localStorage.getItem('accessToken');
    const userString = localStorage.getItem('user');

    if (accessToken && userString) {
      try {
        const user = JSON.parse(userString);

        // Check if the user object has a 'role' property or similar to determine if they are a tutor
        if (user.role === 'tutor') {
          window.location.href = '/tutor_dashboard'; // Or whatever your tutor dashboard link is
        } else {
          window.location.href = '/dashboard'; // Or whatever your regular user dashboard link is
        }
      } catch (e) {
        console.error("Error parsing user data from localStorage:", e);
        // Handle the error, e.g., clear corrupted data or redirect to login
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        // Redirect to login if data is corrupted
      }
    } else {
      // If accessToken or user data doesn't exist, redirect to login or a default page
      // Or your default landing page
    }
  }



  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  slugify = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumeric with -
      .replace(/^-+|-+$/g, '');   // trim dashes
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null }); // Set loading to true and clear previous errors
    try {
      const response = await axios.post('https://api.geoinfoacademy.com/api/login/', {
        email: this.state.email,
        password: this.state.password,
      });

      // Store the access token in local storage (or a more secure mechanism)
      const accessToken = response.data['access'];
      const userData = response.data['user'];

      // Store access token
      localStorage.setItem('accessToken', accessToken);

      // Store user data (stringify it first)
      localStorage.setItem('user', JSON.stringify(userData));
      console.log(response.data);
      console.log('Redirecting to dashboard');
      const course_id = localStorage.getItem("redirectCourseId")
      const course_title = localStorage.getItem("redirectCourseTitle")
      const course_action = localStorage.getItem('redirectCourseaction');

      this.setState({ accessToken: accessToken, user: userData }); // Update state if needed
      if (
        (userData.first_name === "" ||
          userData.last_name === "" ||
          userData.middle_name === "" ||
          userData.phone_number === "" ||
          userData.address === "" ||
          userData.email === "" ||
          userData.country === "" ||
          userData.city === "" ||
          userData.venue === "" ||
          userData.interested_course === "") &&
        // userData.source !== ""&&
        course_action === "apply"
      ) {
        window.location.href = `/description/${course_id}/${this.slugify(course_title)}`;
      } else {


        if (course_action === "apply") {
          localStorage.removeItem('redirectCourseaction');
          try {
            const response = await axios.post(
              `https://api.geoinfoacademy.com/api/interested-courses/`,
              {
                course_id: course_id, // Place course_id in the request body
              },
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            );
            console.log(response.data.message)
            window.location.href = `/description/${course_id}/paymentverify`;
            localStorage.removeItem('redirectCourseId');
          }
          catch (error) {
            console.error("Error initiating payment:", error);
          }
        } else if (course_action === "save") {
          localStorage.removeItem('redirectCourseaction');

          window.location.href = `/description/${course_id}/${this.slugify(course_title)}`
          localStorage.removeItem('redirectCourseId');
          localStorage.removeItem('redirectCourseTitle');
          try {
            const response = await axios.post(
              `https://api.geoinfoacademy.com/api/saved-courses/`,
              {
                course_id: course_id, // Place course_id in the request body
              },
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            );
            console.log(response.data.message)

            // Navigate if already logged in
          }
          catch (error) {
            console.error("Error initiating payment:", error);
          }
        } else {
          window.location.href = '/dashboard';
        }
      }

    } catch (error) {
      console.log("Full error object:", error);
      let errorMessage = "Invalid email or password.";

      if (error.response && error.response.data) {
        const errorData = error.response.data;
        console.log("Parsed error data:", errorData);

        // 1. Direct string
        if (typeof errorData === 'string') {
          // an HTML error page (e.g. a 500) shouldn't be shown to the user
          errorMessage = errorData.trim().startsWith('<')
            ? "Server error. Please try again later."
            : errorData;
        }
        // 2. Django 'detail' string
        else if (typeof errorData.detail === 'string') {
          errorMessage = errorData.detail;
        }
        // 3. Array of messages
        else if (Array.isArray(errorData)) {
          errorMessage = errorData.join(' ');
        }
        // 4. DRF field errors dictionary
        else if (typeof errorData === 'object' && errorData !== null) {
          const errorList = [];

          for (const [field, messages] of Object.entries(errorData)) {
            const fieldMessage = Array.isArray(messages) ? messages.join(' ') : messages;

            if (!isNaN(field) || field === 'non_field_errors') {
              errorList.push(fieldMessage);
            } else {
              errorList.push(`${field}: ${fieldMessage}`);
            }
          }

          if (errorList.length > 0) {
            errorMessage = errorList.join(' | ');
          }
        }
      } else if (error.request) {
        // request was sent but no response came back
        errorMessage = "Network error or server unavailable.";
      } else {
        // a JavaScript error in your own code (not an API error)
        errorMessage = "Something went wrong. Please try again.";
      }

      this.setState({ error: errorMessage });

      setTimeout(() => {
        this.setState({ error: "" });
      }, 7000);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <div className=" account_body ">
        <SignupHeader />
        <h1 className="account_header">Login </h1>
        <p className="account_body">Almost there! Login or create an account</p>
        <div className="account_form_cover">
          <form className="account_form" onSubmit={this.handleSubmit}>
            <label>Email</label><br />
            <input placeholder="Enter Your Email " type="email" id="email" name="email" value={this.state.email} onChange={this.handleChange} required /><br /><br />
            <label htmlFor="password">Password</label><br />
            <input placeholder="Enter Your Password" type="password" id="password" name="password" value={this.state.password} onChange={this.handleChange} required /><br /><br />
            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Logging in..." : "Submit"}
            </button> <br /><br />
            {this.state.error && <p className="account_error">{this.state.error}</p>}
            <p><Link to="/forgotten_password"><span>Forgotten Password</span></Link></p>
            {/* <button className="signup_google"><FaGooglePlusG /> <span>Continue With Google</span></button>
                          */} <GoogleSignup />
            <br />
            <p>New to Geo-Academy? <Link to="/sign_up"><span>Join Us</span></Link></p>
          </form>
        </div>
        <SignupFooter />
      </div>
    )
  }
}

export default Login